import React, { useState, useEffect } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Wallet from '../../Assets/images/w.png';
import Card from '../../Assets/images/c1.png';
import Master from '../../Assets/images/master.png';
import getServices from '../../Services/get-service';
import Constant from '../../Constant';

export default function WalletPayment({ value, onchange }) {
  const [walletBalance, setWalletBalance] = useState(0);

 useEffect(() => {
    getServices.getWalletBalance().then(
      (response) => {
        if (response.data.statusCode === 200) {
          const walletData = response.data.data[0]
          setWalletBalance(walletData.availableBalance)
        } 
      },
      (error) => {
        // console.error(error)
      }
    )
  }, [])
  return (
    <RadioGroup
      aria-labelledby="payment-method-radio-group"
      name="payment-method-radio-group"
      value={value}
      className='w-full'
      onChange={(e) => onchange(e.target.value)}
    >
      {/* Wallet Option */}
      <div className={`w-full rounded-lg border p-3 mb-3 flex items-center justify-between transition-colors ${value === 'wallet' ? 'border-[#00BC67] bg-[#F5FCF8]' : 'border-[#E6E6E7] bg-white'}`}>
        <div className='flex items-center gap-3'>
          <div className='bg-[#E6F8F0] p-2 rounded-full'>
            <img src={Wallet} alt='Wallet' className='w-5 h-5 object-contain' />
          </div>
          <p className='text-[#1E222B] text-[15px] font-[500]'>Wallet</p>
        </div>
        <div className='flex items-center gap-2'>
          <p className='text-[#1E222B] font-[600] text-[15px]'>
            NGN {Constant.FormatNumber(walletBalance)}
          </p>
          <FormControlLabel
            value="wallet"
            control={
              <Radio
                sx={{
                  color: '#C4C4C4',
                  '&.Mui-checked': {
                    color: '#00BC67',
                  },
                }}
              />
            }
            label=""
            className="m-0"
          />
        </div>
      </div>

      {/* Card Option */}
      {/* <div className={`w-full rounded-lg border p-3 flex items-center justify-between transition-colors ${value === 'card' ? 'border-[#00BC67] bg-[#F5FCF8]' : 'border-[#E6E6E7] bg-white'}`}>
        <div className='flex items-center gap-3'>
          <div className='bg-[#E6F8F0] p-2 rounded-full'>
            <img src={Card} alt='Card' className='w-5 h-5 object-contain' />
          </div>
          <p className='text-[#1E222B] text-[15px] font-[500]'>Card</p>
        </div>
        <div className='flex items-center gap-2'>
          <p className='text-[#808285] font-[500] text-[15px]'>
            **** 2898
          </p>
          <img src={Master} alt='Mastercard' className='w-8 h-auto object-contain mr-1' />
          <FormControlLabel
            value="card"
            control={
              <Radio
                sx={{
                  color: '#C4C4C4',
                  '&.Mui-checked': {
                    color: '#00BC67',
                  },
                }}
              />
            }
            label=""
            className="m-0"
          />
        </div>
      </div> */}
    </RadioGroup>
  );
}